// extracted by mini-css-extract-plugin
export default {"PropertyListPage":"styles_PropertyListPage__KCfoU","container":"styles_container__XpdJ0"};